import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from "./../translate.service";

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import {swaggerApiService} from '../services/swaggerApi.service';
import { ApiModel } from '../classes/api_model';
import {JSGenerateRSAKey} from '../services/JSGenerateRSAKey';
import { environment } from 'src/environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
export interface DetailData {
  title: string;
  english: string;
  french: string;
  thumb: string;
  khmer: string;
  imgs: [];
  date: string;
}
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { MatTabGroup } from "@angular/material";
import { HttpResponse } from '@angular/common/http';


interface HomeCarouselItem {
  _id?: string;
  id?: string;
  title?: string;
  message?: string;
  thumbs?: string;
  imageUrl: string;
}

interface HomeNewsItem {
  id: string;
  message?: string;
  titleKh?: string;
  titleEn?: string;
  titleFr?: string;
  khDes?: string;
  enDes?: string;
  frDes?: string;
  displayTitle: string;
  displayDescription: string;
  displayDate: string;
  imageUrl: string;
  videoUrl: string;
  isVideo: boolean;
  isDirectVideo: boolean;
  url: string;
  created_time?: string;
  attachments?: any;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  @ViewChild("about", { static: false }) aboutTab: ElementRef;
  //
  @Output() newsEmitter = new EventEmitter();
  // toolList = [];
  isLoading = false;
  isEventsLoading = false;
  carouselList = [];
  newsList = [];
  length = 0;
  pageSize = 0;
  selectedTab = -1;
  key:JSGenerateRSAKey;
  @Input() currentLanguage: string;
  //get News from FB
  newsListFB: HomeNewsItem[] = [];
  private readonly fallbackImage = './assets/icon-lcs.webp';
  readonly slidingBaseUrl = `${(environment as any).apiBaseUrl || 'https://api.sathachak.com'}/sliding/`;
  private mapCarouselItem(item: any): HomeCarouselItem {
    const imageUrl = item && item.thumbs ? this.slidingBaseUrl + item.thumbs : this.fallbackImage;
    return {
      ...item,
      imageUrl,
      message: item && item.message ? item.message : ''
    };
  }
   private mapFacebookPost(item: any, url: string): HomeNewsItem {
    const parsed = this.parseFacebookMessage(item.message || '');
    const media = this.getFacebookMedia(item);
    const news = {
      ...item,
      titleKh: parsed.titleKh,
      titleEn: parsed.titleEn,
      titleFr: parsed.titleFr,
      khDes: parsed.khDes,
      enDes: parsed.enDes,
      frDes: parsed.frDes,
      displayTitle: '',
      displayDescription: '',
      displayDate: '',
      imageUrl: media.imageUrl,
      videoUrl: media.videoUrl,
      isVideo: media.isVideo,
      isDirectVideo: media.isDirectVideo,
      url
    } as HomeNewsItem;

    return this.withLocalizedNewsDisplay(news);
  }
   private parseFacebookMessage(message: string): any {
    const sections = message.split('\n|\n');
    const kh = this.parseMessageSection(sections[0], message);
    const en = this.parseMessageSection(sections[1], '');
    const fr = this.parseMessageSection(sections[2], '');

    return {
      titleKh: kh.title,
      khDes: kh.description,
      titleEn: en.title,
      enDes: en.description || kh.description,
      titleFr: fr.title,
      frDes: fr.description || kh.description
    };
  }
   private getFacebookMedia(item: any): { imageUrl: string; videoUrl: string; isVideo: boolean; isDirectVideo: boolean } {
    const attachment = item && item.attachments && item.attachments.data && item.attachments.data[0]
      ? item.attachments.data[0]
      : null;
    const media = attachment && attachment.media ? attachment.media : null;
    const type = attachment && attachment.type ? String(attachment.type).toLowerCase() : '';
    const isVideoAttachment = type.indexOf('video') !== -1;
    const rawVideoUrl = isVideoAttachment ? this.getFacebookVideoUrl(attachment) : '';
    const videoUrl = rawVideoUrl ? this.getFacebookVideoEmbedUrl(rawVideoUrl) : '';

    return {
      imageUrl: media && media.image && media.image.src
        ? media.image.src
        : item && item.full_picture
          ? item.full_picture
          : this.fallbackImage,
      videoUrl,
      isVideo: isVideoAttachment && !!videoUrl,
      isDirectVideo: videoUrl.indexOf('.mp4') !== -1
    };
  }
  private withLocalizedNewsDisplay(news: HomeNewsItem): HomeNewsItem {
    return {
      ...news,
      displayTitle: this.getLocalizedText(news.titleKh, news.titleEn, news.titleFr),
      displayDescription: this.getLocalizedText(news.khDes, news.enDes, news.frDes),
      displayDate: this.formatDisplayDate(news.created_time)
    };
  }
  private formatDisplayDate(createdTime: string): string {
    if (!createdTime) {
      return '';
    }

    const date = new Date(createdTime);
    if (isNaN(date.getTime())) {
      return '';
    }

    const day = this.padDatePart(date.getDate());
    const month = this.padDatePart(date.getMonth() + 1);
    const year = String(date.getFullYear());
    return this.convertDate(`${day}-${month}-${year}`);
  }
  private padDatePart(value: number): string {
    return value < 10 ? `0${value}` : String(value);
  }
  private parseMessageSection(section: string, fallback: string): { title: string; description: string } {
    const cleanSection = this.normalizePreviewText(section);
    const cleanFallback = this.normalizePreviewText(fallback);

    if (!cleanSection) {
      return { title: '', description: cleanFallback };
    }

    const parts = cleanSection.split(/\s*-{5,}\s*/);
    if (parts.length < 2) {
      return { title: '', description: cleanSection || cleanFallback };
    }

    return {
      title: parts[0] || '',
      description: parts.slice(1).join(' ').trim() || cleanFallback
    };
  }
  private normalizePreviewText(value: string): string {
    return (value || '')
      .replace(/\r/g, '\n')
      .replace(/\n+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  private getFacebookVideoUrl(attachment: any): string {
    if (attachment && attachment.media && attachment.media.source) {
      return attachment.media.source;
    }

    if (attachment && attachment.url) {
      return attachment.url;
    }

    if (attachment && attachment.target && attachment.target.url) {
      return attachment.target.url;
    }

    return '';
  }
   private getFacebookVideoEmbedUrl(url: string): string {
    if (!url) {
      return '';
    }

    if (url.indexOf('facebook.com/plugins/video.php') !== -1 || url.indexOf('.mp4') !== -1) {
      return url;
    }

    return 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(url) + '&show_text=false&width=500';
  }
 

  private getLocalizedText(kh: string, en: string, fr: string): string {
    if (this.currentLanguage === 'fr' && fr) {
      return fr;
    }

    if (this.currentLanguage === 'en' && en) {
      return en;
    }

    return kh || en || fr || '';
  }

  constructor(private db: AngularFirestore, public dialog: MatDialog,private route: ActivatedRoute,
    private router: Router,config: NgbCarouselConfig,private translate: TranslateService,
    private _swaggerApiService:swaggerApiService,private _snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,) {
      // customize default values of carousels used by this component tree
    config.interval = 5000;
    config.keyboard = false;
    config.pauseOnHover = false;
    //end
  }

  onNewsClicked() {
    console.log("click from home !!!");
    this.newsEmitter.emit();
    console.log("after emitter !!!");
  }

  onMenuClicked(index){
    this.router.navigate(['contents',index,this.currentLanguage]);
  }
  onNewsImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img.src.indexOf('assets/icon-lcs.webp') !== -1) {
      return;
    }
    img.classList.add('home-event-fallback-image');
    img.src = this.fallbackImage;
  }

  trackByNewsId(index: number, news: HomeNewsItem): string {
    return news && news.id ? news.id : String(index);
  }

  ngOnInit() 
  {
    this.key=new JSGenerateRSAKey();

    let objSliding=new ApiModel();
    objSliding.public_key=this.key.getPublicKey();
    objSliding.modified_date=new Date().toISOString();
    objSliding.limit=50;
    this._swaggerApiService.postCarousel(objSliding)
      .subscribe
      (
        data=>
        {
          let objDecrypt=new ApiModel();
          objDecrypt.encryptedData=data;
          objDecrypt.private_key=this.key.getPrivateKey();
          this._swaggerApiService.postDecrypted(objDecrypt)
            .subscribe
            (
              data=>
              {
                if(data.statusCode==200 && data.item.length>0)
                {
                  // console.info("caroucel = ",data);
                  data.item.forEach(element => 
                    {
                      this.carouselList.push(element);
                    }
                  );
                }
                else if(data.statusCode==200 && data.item.length<=0)
                {
                  //Toast message to users
                  this._snackBar.open("oops! no more records found.", "OK", {
                    duration: 2000
                  });
                }
                else
                {
                  //Toast message to users
                  this._snackBar.open(data.message, "OK", {
                    duration: 2000
                  });
                }
              },(error:HttpResponse<Response>) => {
                let errorMsg=error['message'];
                this._snackBar.open("Carousel Decrypted Res_Err: "+errorMsg, "OK", {
                  duration: 2000
                });
              }
            )
          //auto click the ABOUT_LC Tab
          this.clickNextTab();
          this.clickNextSubTab();
        },(error:HttpResponse<Response>) => {
          let errorMsg=error['message'];
          this._snackBar.open("Carousel Res_Err: "+errorMsg, "OK", {
            duration: 2000
          });
          //auto click the ABOUT_LC Tab
          this.clickNextTab();
          this.clickNextSubTab();
        }
      )
      this.recentlyEventsFB();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentLanguage && !changes.currentLanguage.firstChange && this.newsListFB.length > 0) {
      this.newsListFB = this.newsListFB.map(news => this.withLocalizedNewsDisplay(news));
      this.cdRef.markForCheck();
    }
  }
  recentlyEventsFB()
  {
    this.isEventsLoading = true;
    this._swaggerApiService.postPageToken().subscribe(data=>
      {
        let Datares=data;
        if(Datares.statusCode==200){
          let uri=Datares.item.token;
          //call get new Feed from FB graph API
          this.getNewFeedFBpage(uri);
        }
      },(error:HttpResponse<Response>) => 
      {
        this.isEventsLoading = false;
        //get error response from FB
        // let errorMsg=error['error'].error.message;
        this._snackBar.open(error['error'], "OK", {
          duration: 2000
        });
      }
    );
  }
  getNewFeedFBpage(uri){
    //old FB Token request
    // this._swaggerApiService.getNewsFB("https://graph.facebook.com/v6.0/1528139114067649/feed?fields=message,permalink_url,full_picture,attachments,created_time&limit=10&access_token=EAAP4Crx1tZAUBANewu0wDgrhJNoMFDzQYHS164b442GrsbmcGzjthZA9WZBLwdMvUFjAGYToPC7rBPoyNhPcFlRKpowqhKZAwB5ZAbJ2yxwlY24juUHqR1MDRkrEfgLZAcCZCNqb7H3ljCEuy5cBz64RH0QUpOsDeHJ01uzLRNrS9Knk3Emrey9")
    this._swaggerApiService.getNewsFB(uri)
    .subscribe
    (
	      response =>
	      {
	        //old FB Token request
	        // let current_url="https://graph.facebook.com/v6.0/1528139114067649/feed?fields=message,permalink_url,full_picture,attachments,created_time&limit=10&access_token=EAAP4Crx1tZAUBANewu0wDgrhJNoMFDzQYHS164b442GrsbmcGzjthZA9WZBLwdMvUFjAGYToPC7rBPoyNhPcFlRKpowqhKZAwB5ZAbJ2yxwlY24juUHqR1MDRkrEfgLZAcCZCNqb7H3ljCEuy5cBz64RH0QUpOsDeHJ01uzLRNrS9Knk3Emrey9";
	        let current_url=uri;
	        // console.log('*****',this.isLoading );
	        
	        if(response.data.length>0)
	        {
	          this.newsListFB = response.data
	            .filter(element => element && element.message != undefined)
	            .map(element => this.mapFacebookPost(element, current_url));
	        }
	        else
	        {
	          this.newsListFB = [];
	          this._snackBar.open("oops! no more records found.", "OK", {
	            duration: 2000
	          });
	        }
	        this.isEventsLoading = false;
	        // console.info("response = ",response);
	      },(error:HttpResponse<Response>) => 
	        {
	          this.isEventsLoading = false;
	          //get error response from FB
	          let errorMsg=error['error'].error.message;
          this._snackBar.open(errorMsg, "OK", {
            duration: 2000
          });
        }
    );
  }

  //auto click the ABOUT_LC Tab
  @ViewChild("demoTab", { static: false }) demoTab: MatTabGroup;

  public clickNextTab() {
    this.goToNextTabIndex(this.demoTab);
  }

    //auto click the ABOUT_LC Tab
    @ViewChild("demoSubTab", { static: false }) demoSubTab: MatTabGroup;

    public clickNextSubTab() {
      this.goToNextTabIndex(this.demoSubTab);
    }

  // ============
  // HELPER
  // ============

  private goToNextTabIndex(tabGroup: MatTabGroup) {
    if (!tabGroup || !(tabGroup instanceof MatTabGroup)) return;

    const tabCount = tabGroup._tabs.length;
    tabGroup.selectedIndex = (tabGroup.selectedIndex+1) % tabCount;
  }
  //end auto
  navigateDetailNewTab(news){
    // window.open('read-detail', '_blank');
    // this.router.navigate(['read-detail'], { queryParams: { data:JSON.stringify(news),newsList:JSON.stringify(this.newsList)} });
    // this.router.navigate(['read-detail',news.newsId]);
    let url=news.url.replace("https://graph.facebook.com/",'');
    url=url.split("/");
    // console.info("url = ",url);
    let parameter=url[2].split("?");
    // console.info("parameter = ",parameter);
    parameter[1]=parameter[1].replace(/=/g,'@@');
    let fb_url=url[0]+'/'+url[1]+'/'+parameter[0]+'/'+parameter[1];
    window.open('details/article/'+news.id+'/YES'+'/'+fb_url+'/'+this.currentLanguage,'_blank' );
  }
  toKhmerNumber(str){
    var khNumber = str.toString();

    khNumber = khNumber.replace(/0/g,'០')
    khNumber = khNumber.replace(/1/g,'១')
    khNumber = khNumber.replace(/2/g,'២')
    khNumber = khNumber.replace(/3/g,"៣")
    khNumber = khNumber.replace(/4/g,"៤")
    khNumber = khNumber.replace(/5/g,"៥")
    khNumber = khNumber.replace(/6/g,"៦")
    khNumber = khNumber.replace(/7/g,"៧")
    khNumber = khNumber.replace(/8/g,"៨")
    khNumber = khNumber.replace(/9/g,"៩")
    
    return khNumber
  }
  toKhmerMonth(str){
    var khNumber = str.toString();

    khNumber = khNumber.replace(/01/g,this.translate.data.MONTH_01)
    khNumber = khNumber.replace(/02/g,this.translate.data.MONTH_02)
    khNumber = khNumber.replace(/03/g,this.translate.data.MONTH_03)
    khNumber = khNumber.replace(/04/g,this.translate.data.MONTH_04)
    khNumber = khNumber.replace(/05/g,this.translate.data.MONTH_05)
    khNumber = khNumber.replace(/06/g,this.translate.data.MONTH_06)
    khNumber = khNumber.replace(/07/g,this.translate.data.MONTH_07)
    khNumber = khNumber.replace(/08/g,this.translate.data.MONTH_08)
    khNumber = khNumber.replace(/09/g,this.translate.data.MONTH_09)
    khNumber = khNumber.replace(/10/g,this.translate.data.MONTH_10)
    khNumber = khNumber.replace(/11/g,this.translate.data.MONTH_11)
    khNumber = khNumber.replace(/12/g,this.translate.data.MONTH_12)
    
    return khNumber
  }
  convertDate(date){
    let dateList,dateStr='';
    let dateLabel=['ថ្ងៃទី','ខែ','ឆ្នាំ'];
    dateList=date.split('-');
    dateList[1]=this.toKhmerMonth(dateList[1]);
    if(this.currentLanguage=='km'){
      for(let i=0;i<dateList.length;i++){
        dateList[i]=this.toKhmerNumber(dateList[i]);
        dateStr+=dateLabel[i]+dateList[i]+' ';
      }
    } else {
      for(let i=0;i<dateList.length;i++){
        dateStr+=dateList[i]+' ';
      }
    }
    return dateStr;
  }
  openDialog(news) {
    let str: String = news.images;
    let imgList = str.split(",");

    const dialogRef = this.dialog.open(NewsDetail, {
      data: {
        title: news.title,
        english: news.english,
        french: news.french,
        thumb: news.thumb,
        imgs: imgList,
        khmer: news.khmer
      }
    });
    // title: string;
    // english: string;
    // french: string;
    // img: string;
    // images: [];
    // date: string;
    dialogRef.afterClosed().subscribe(result => {});
  }

  // MatPaginator Output
}

@Component({
  selector: "news-detail",
  templateUrl: "news-detail.html"

})
export class NewsDetail {
  constructor(
    public dialogRef: MatDialogRef<NewsDetail>,
    @Inject(MAT_DIALOG_DATA) public data: DetailData
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
